import React, { useEffect, useId, useRef, useState } from 'react';
import { Dialog } from './Dialog';
import { Button } from './Button';

export const ConfirmDialog = ({ title, children, confirmLabel, cancelLabel = 'Volver', onConfirm, onClose }: {
  title: string; children: React.ReactNode; confirmLabel: string; cancelLabel?: string;
  onConfirm: () => void | Promise<void>; onClose: () => void;
}) => {
  const titleId = useId();
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const [error, setError] = useState('');
  const errorRef = useRef<HTMLParagraphElement>(null);
  useEffect(() => { if (error) errorRef.current?.focus(); }, [error]);
  const close = () => { if (!lock.current) onClose(); };
  return <Dialog labelledBy={titleId} onClose={close} busy={busy} className="flex items-center justify-center p-4">
    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={close} />
    <form className="relative w-full max-w-md max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-3xl bg-white dark:bg-slate-950 p-5 sm:p-8 space-y-5"
      onSubmit={async event => {
        event.preventDefault();
        if (lock.current) return;
        lock.current = true; setBusy(true); setError('');
        try { await onConfirm(); onClose(); }
        catch (failure: any) { setError(failure?.response?.data?.message || failure?.message || 'No se pudo completar. Revisa los datos e intenta de nuevo.'); }
        finally { lock.current = false; setBusy(false); }
      }}>
      <h2 id={titleId} tabIndex={-1} className="text-xl font-black break-words">{title}</h2>
      <div className="text-sm space-y-3">{children}</div>
      {error && <p ref={errorRef} role="alert" tabIndex={-1} className="text-red-700 dark:text-red-300">{error}</p>}
      <fieldset disabled={busy} className="flex flex-col gap-3">
        <Button type="button" variant="outline" onClick={close}>{cancelLabel}</Button>
        <Button type="submit">{busy ? 'Procesando…' : confirmLabel}</Button>
      </fieldset>
    </form>
  </Dialog>;
};
